import { render, staticRenderFns } from "./IntroAnimation.vue?vue&type=template&id=6beff79a&"
import script from "./IntroAnimation.vue?vue&type=script&lang=js&"
export * from "./IntroAnimation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports